'use strict';

const angular = require('angular');

import { IPickupUserEvent } from '../interfaces';

export class HelpOutComponent{
  // userEvent: IPickupUserEvent;
  // userId: string;
  // $http: ng.IHttpService;

  // /*ngInjector*/
  // constructor($http, Auth)
  // {
  //   this.$http = $http;

  //   // Get the cuurent user
  //   Auth.getCurrentUser()
  //     .then(user => this.userId = user._id);
  // }

  $onInit() {
    // this.userEvent = (this as any).resolve.userEvent;
    // console.log(this.userEvent);
    // this.userId    = (this as any).resolve.userId;
  }

  ok() {
    // // Get the pickup event id from original or override
    // let pickupEventId = this.userEvent.pickupEvent._id;
    // if (this.userEvent.pickupEventOverride) {
    //   pickupEventId = this.userEvent.pickupEventOverride._id;
    // }

    // // Get the userId or null depending of help out value
    // let userId = this.userEvent.pickupEvent.helpOut ? null : this.userId;

    // Patch to help out
    // this.$http.patch('/api/pickupEvents/addHelpout/'+ pickupEventId, {helpOut: userId})
    // .then(res => {
    //   console.log(res);
    //   if (res.status == 200) {
    //     // userEvent.pickupEvent.helpOut = this.userId;
    //     console.log(res);
    //     (this as any).close({$value: null});
    //   }
    // });

    (this as any).close({$value: true});

  };

  cancel() {
    (this as any).dismiss({$value: 'cancel'});
  };
}


export default angular.module('terrappApp.schedule')
  .component('helpOut', {
    template: require('./helpOut.html'),
    controller: HelpOutComponent,
    controllerAs: '$ctrl',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
    },
  }).name;



// WEBPACK FOOTER //
// ./client/app/schedule/helpOut.component.ts